
import React from "react";
import { Globe } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center justify-center w-9 h-9 rounded-full hover:bg-muted transition-colors">
        <Globe className="h-5 w-5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={() => setLanguage('hu')}
          className={`flex items-center gap-2 ${language === 'hu' ? 'font-medium' : ''}`}
        >
          🇭🇺 Magyar
          {language === 'hu' && <span className="ml-1 h-2 w-2 rounded-full bg-primary"></span>}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setLanguage('en')}
          className={`flex items-center gap-2 ${language === 'en' ? 'font-medium' : ''}`}
        >
          🇬🇧 English
          {language === 'en' && <span className="ml-1 h-2 w-2 rounded-full bg-primary"></span>}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
